<template>
	<div class="activity-card" @click="handleClick">
		<el-image class="activity-card-image" :src="formattedItem.image" fit="cover" lazy></el-image>
		<div class="activity-card-content">
			<h4 class="text-overflow2">{{ formattedItem.title }}</h4>
			<p class="activity-card-date">
				{{ formatDateFn(formattedItem.time) }}
			</p>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { dateFormatYearMonthDate } from '@/utils/format';

const props = defineProps({
	item: {
		type: Object,
		default: () => ({})
	},
	formatter: {
		type: Function,
		default: null
	}
});

const emit = defineEmits(['click']);

const formatDateFn = date => dateFormatYearMonthDate(date);

const formattedItem = computed(() => {
	if (props.formatter && typeof props.formatter === 'function') {
		const formattedData = props.formatter(props.item);
		// 将格式化后的数据与原始数据合并，formatter 返回的字段优先级更高
		return { ...props.item, ...formattedData };
	}
	return props.item;
});

const handleClick = () => {
	emit('click');
};
</script>

<style lang="less" scoped>
.activity-card {
	cursor: pointer;
	background: #fff;
	padding: 12px;

	.activity-card-image {
		display: block;
		height: 150px;
	}
	.activity-card-content {
		margin-top: 12px;

		h4 {
			color: #1d2129;
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 24px; /* 150% */
			height: 48px;
		}
		.activity-card-date {
			margin-top: 8px;
			color: #86909c;
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 18px; /* 128.571% */
		}
	}
}
</style>
